import React, { useEffect } from 'react'
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import { useHistory } from 'react-router';
import NumberInput from '../../components/Inputs/NumberInput';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import useInvoices from '../../store/invoices/invoicesContext';
import DateInput from '../../components/Inputs/DateInput';
import FileInput from '../../components/Inputs/FileInput';
import Loader from 'react-spinners/MoonLoader';
import { COLORS } from '../../config';

function AddInvoice() {
  const history = useHistory();

  const {
    uploadInvoice
  } = useInvoices();

  const [formError, setFormError] = React.useState({
    field: '',
    msg: ''
  });
  const [isSending, setIsSending] = React.useState(false);

  const [invoiceData, _setInvoiceData] = React.useState({
    invoiceDate: null,
    amount: null,
  });

  const [ invoiceFile, setInvoiceFile ] = React.useState(null);

  const setInvoiceData = (newVal) => _setInvoiceData({...invoiceData, ...newVal});
  
  const handleCreate = () => {
    let element;
    if (!invoiceData.invoiceDate) {
      element = document.getElementById('invoiceDate');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return setFormError({
        field: 'invoiceDate',
        msg: "Please enter a valid date for the invoice."
      });
    }
    if (!invoiceData.amount) {
      element = document.getElementById('amount');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return setFormError({
        field: 'amount',
        msg: "Please enter an invoice amount."
      });
    }
    if (!invoiceFile) {
      element = document.getElementById('invoiceFile');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return setFormError({
        field: 'invoiceFile',
        msg: "Please include a PDF file to upload."
      });
    }
    setIsSending(true);

    uploadInvoice(invoiceFile, invoiceData).then(() => {
      history.goBack();
      setIsSending(false)
    }).catch(err => {
      setIsSending(false)
    });
  }

  const handleFileUpload = (e) => { 
    setFormError({
      field: '',
      msg: ''
    })
    setInvoiceFile(e.target.files[0]);
  } 
  
  return (
    <div className="flex flex-col">
      <div className="bg-white rounded shadow py-12 px-10">
        <div className='flex justify-between items-center'>
          <h1 className="mb-10 text-2xl text-secondary">Invoice information</h1>
        </div>
        <div className='grid grid-cols-4 gap-y-4'>
          {!isSending && 
          <>
            <DateInput id='invoiceDate' label='Invoice date*' inputClass='col-span-3' value={invoiceData.invoiceDate} onChange={(e) => setInvoiceData({invoiceDate: e.target.value})}/>
            {formError.field === 'invoiceDate' && 
            <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
            }
            <NumberInput id='amount' min={0} label='Amount*' inputClass='col-span-3' value={invoiceData.amount} onChange={(e) => setInvoiceData({amount: e.target.value})}/>
            {formError.field === 'amount' && 
            <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
            }
            <FileInput id={'invoiceFile'} label='Invoice File*' className='col-span-3' right handleFileUpload={handleFileUpload} buttonText='Select file' accept='.pdf'/>
            {formError.field === 'invoiceFile' &&
            <span className="text-red-400 text-sm">{formError.msg}</span>
            }
          </>
          }
          {isSending && 
          <div className='flex justify-around min-h-170 pt-8'>
            <Loader color={COLORS.colorPrimary}/>
          </div> 
          }
        </div>
      </div>
      <div className='flex flex-row-reverse mt-8 mb-4'>
        <PrimaryButton text='Create' onClick={handleCreate} className='min-w-180 ml-4'/>
        <SecondaryButton text='Cancel' onClick={() => history.goBack()} className='min-w-180'/>
      </div>
    </div>
  )
}

export default AddInvoice
